import * as DatasetHelper from '../dataset-helper';

import calculateAccumulation from './accumulation-calculator';
import calculateDivide from './divide-calculator';
import calculateMean from './mean-calculator';
import calculateMinus from './minus-calculator';
import calculateQuota from './quota-calculator';
import calculateSqrt from './sqrt-calculator';
import calculateSquare from './square-calculator';
import calculateSum from './sum-calculator';
import calculateSelectionStatistics from './selection-statistics-calculator';
import calculateVariance from './variance-calculator';
import calculateWorstCaseVariance from './worst-case-variance-calculator';

/**
 * Helper class for calculating variance of site variables.
 */
export default class FlexibleCalculator {

  /**
   * Perform the calculations defined in the 'calculationDefn' and return the single result value.
   */
  calculate(calculationDefn, dataset, referenceSitesHash, selectedSiteIds) {

    const calculationResult = this.performCalculations(calculationDefn, dataset, referenceSitesHash,
      selectedSiteIds);
    return calculationResult[calculationDefn.result];
  }

  /**
   * Perform the calculations defined in the 'calculationDefn' but return the calculation object.
   */
  performCalculations(calculationDefn, dataset, referenceSitesHash, selectedSiteIds) {

    // Calculate the initial statistics.
    const calculations = calculateSelectionStatistics(calculationDefn, dataset, referenceSitesHash,
      selectedSiteIds);

    // Step through the calculation steps as configured.
    calculationDefn.steps.forEach(calculationStepDefn => {

      switch (calculationStepDefn.type) {

        case 'accumulate':
          calculateAccumulation(calculations, dataset, referenceSitesHash, selectedSiteIds,
            calculationDefn.categoryField.fieldId, calculationStepDefn);
          break;

        case 'divide':
          calculateDivide(calculations, dataset, calculationDefn.categoryField.fieldId,
            calculationStepDefn);
          break;

        case 'mean':
          calculateMean(calculations, dataset, calculationDefn.categoryField.fieldId,
            calculationStepDefn);
          break;

        case 'minus':
          calculateMinus(calculations, dataset, calculationDefn.categoryField.fieldId,
            calculationStepDefn);
          break;

        case 'quota':
          calculateQuota(calculations, dataset, calculationDefn.categoryField.fieldId,
            calculationDefn.subCategoryField.fieldId, calculationStepDefn);
          break;

        case 'sqrt':
          calculateSqrt(calculations, dataset, calculationDefn.categoryField.fieldId,
            calculationStepDefn);
          break;

        case 'square':
          calculateSquare(calculations, dataset, calculationDefn.categoryField.fieldId,
            calculationStepDefn);
          break;

        case 'sum':
          calculateSum(calculations, dataset, calculationDefn.categoryField.fieldId,
            calculationStepDefn);
          break;

        case 'variance':
          calculateVariance(calculations, dataset, calculationDefn.categoryField.fieldId,
            calculationStepDefn);
          break;

        case 'worstCaseVariance':
          calculateWorstCaseVariance(calculations, dataset,
            calculationDefn.categoryField.fieldId, calculationStepDefn);
          break;

      }

    });

    return calculations;

  }

}



// WEBPACK FOOTER //
// ./src/app/utils/calculators/flexible-calculator.js